module.exports = __webpack_public_path__ + "img/95202fe.png";